import { setWorkerUrl } from 'maplibre-gl'

// Bundlers can't resolve maplibre's own worker location via import.meta.url
import maplibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url'

setWorkerUrl(maplibreWorkerUrl)
